import { useForm } from "react-hook-form"
import { useToast } from "../../../../hooks/useToast"
import { AdministrarPacEdit, ArgCrearPacDTO, PacModal } from "../models/administrarPac"
import { Dialog, DialogContent, DialogTitle, Grid, Grid2 } from "@mui/material"
import MButton from "../../../../components/inputs/yup/materialui/mButton"
import InputNumber from "../../../../components/inputs/yup/materialui/inputNumber"
import InputSelect from "../../../../components/inputs/yup/materialui/inputSelect";
import InputFecha from "../../../../components/inputs/yup/materialui/inputFecha";
import InputText from "../../../../components/inputs/yup/materialui/inputText";
import { useEffect, useState } from "react"
import { getValoresDominio } from "../../../../services/servicesDominio"
import { Dominios, StatusCode, TipoProducto } from "../../../../utils/enums"
import { AxiosResponse } from "axios"
import { selectorTransversal } from "../../../../dtos/selector"
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { getValidar, editarPac, getCuotaPac } from "../service/servicePac";
import { da, id } from "date-fns/locale"
import FechaPrimeraFirmaForm from "../../../detalleMutuo/components/fechaPrimeraFirma"
import { getBancos } from "../../../detalleMutuo/services/serviceSubsidios"
import { set } from "date-fns"
import { ListResponseDto } from "../../../../dtos/ListResponseDto"
import { Banco } from "../../../detalleMutuo/hooks/useSubsidioMutuo"


interface IProps {
    show: boolean
    datosEditar: AdministrarPacEdit | undefined
    onHide: () => void
    refresh: () => void
    isEditing?: boolean
}

const schema = yup.object({
    //mutuoId: yup.number().notRequired(),
    llavePac: yup
        .string()
        .required("Llave PAC es requerida")
        .matches(/^\d+$/, "Solo se permiten números"),
    cuentaCorriente: yup
        .string()
        .required("El número de cuenta corriente es requerido")
        .matches(/^[\d-]+$/, "Solo se permiten números y guiones"),
    bancoCodigo: yup.string().required("Banco es requerido"),
    fechaPrimerDescuento: yup.date().required("Fecha primer descuento es requerido"),
    tipoCuota: yup.string().required("Tipo cuota es requerido"),
    diaCobro: yup.string().required("Dia de cobro es requerido"),
    numeroMandato: yup
        .number()
        .nullable()
        .transform((value, originalValue) =>
            originalValue === '' ? null : value
        )
        .notRequired(),
    numeroOperacion: yup.string().required("Numero de operacion es requerido"),
    estado: yup.string().required("Estado es requerido"),
    montoCuota: yup
        .number()
        .typeError("El monto de cuota es requerido")
        .required("El monto de cuota es requerido")
        .min(0, "El monto de cuota no puede ser menor a 0"),
    tipoMoneda: yup.string().required("Tipo de moneda es requerido"),
});

const ModalPac: React.FC<IProps> = ({ show, datosEditar, onHide, refresh, isEditing = false }) => {
    const { addToast } = useToast();

    const [optionsBanco, setOptionsBanco] = useState<selectorTransversal[]>([]);
    const [optionsCuota, setOptionsCuota] = useState<selectorTransversal[]>([]);
    const [optionsDiaCobro, setOptionsDiaCobro] = useState<selectorTransversal[]>([]);
    const [optionsEstado, setOptionsEstado] = useState<selectorTransversal[]>([]);
    const [optionsMoneda, setOptionsMoneda] = useState<selectorTransversal[]>([]);
    const [optionsGlobalQuotas, setOptionsGlobalQuotas] = useState<selectorTransversal[]>([]);
    const [optionsCuotaValor, setOptionsCuotaValor] = useState()
    const [montoCuota, setMontoCuota] = useState<number>(0);
    const [montoCuotaIntermedioOriginal, setMontoCuotaIntermedioOriginal] = useState<number>(0);
    const [tipoMonedaIntermedioOriginal, setTipoMonedaIntermedioOriginal] = useState<string>('UF');


    const isValueEmpty = (value: any): boolean => {
        if (value === null || value === undefined) {
            return true;
        }
        if (typeof value === 'string' && value.trim() === '') {
            return true;
        }
        if (typeof value === 'number' && value === 0) {
            return true;
        }
        return false;
    };

    const isCreateMode = isValueEmpty(datosEditar?.llavePac) || isValueEmpty(datosEditar?.estado);
    const isTradicional = datosEditar?.tipoProducto === TipoProducto.MHT || datosEditar?.tipoProducto === TipoProducto.MHD;


    const {
        formState: { errors },
        handleSubmit,
        reset,
        setValue,
        trigger,
        control,
        watch,
    } = useForm<PacModal>({
        mode: 'onBlur',
        resolver: yupResolver(schema),
    })

    const dataForm = watch();

    const datosPac = async () => {
        const resp = await getCuotaPac(datosEditar!.mutuoId)
        if (resp.status === StatusCode.Ok) {
            const data = await resp.data
            setOptionsCuotaValor(data)
        }
    }


    useEffect(() => {
        if (isEditing && show) {
            const cargarDatosPac = async () => {

                const response = await getValidar(datosEditar!.mutuoId);

                if (response.status === StatusCode.Ok) {

                    const data = response.data;
                    const diaCobroFormateado = data.diacobro
                        ? String(data.diacobro).padStart(2, '0')
                        : '';
                    setValue('mutuoId', data.mutuoId === 0 ? datosEditar!.mutuoId : data.mutuoId);
                    setValue('llavePac', data.llavepac);
                    setValue('bancoCodigo', data.bancoCodigo);
                    setValue('fechaPrimerDescuento', data.fechaprimerdescuento || new Date());
                    setValue('tipoCuota', data.tipocuota);
                    setValue('diaCobro', diaCobroFormateado);
                    setValue('numeroMandato', data.numeromandato ?? null);
                    setValue('numeroOperacion', data.numerooperacion);
                    setValue('cuentaCorriente', data.numerocuentacorriente);
                    setValue('estado', data.estado);
                    setValue('montoCuota', data.montocuota);
                    setValue('tipoMoneda', data.codigomoneda);
                    setValue('observaciones', data.observaciones || '');

                    trigger();
                    setMontoCuotaIntermedioOriginal(data.montocuota ?? 0);
                    setTipoMonedaIntermedioOriginal(data.codigomoneda ?? 'UF');
                }

            };
            cargarDatosPac();
        } else {
            reset();
            setValue('id', datosEditar?.mutuoId)
            setValue('numeroOperacion', datosEditar?.numeroOperacion ?? '')
        }
    }, [datosEditar, show, setValue, reset, addToast, isEditing]);

    const tipoBanco = async () => {
        const resp: AxiosResponse<ListResponseDto<Banco>> = await getBancos()
        if (resp.status === StatusCode.Ok) {
            const data: Banco[] = await resp.data.items;
            const options = data.map((m: any) => ({
                label: m.descripcion,
                value: m.codigo,
            }));
            setOptionsBanco(options)
        }
        return;
    }

    const tipoCuota = async () => {
        const resp: AxiosResponse<ListResponseDto<selectorTransversal>> = await getValoresDominio(Dominios.TIPO_CUOTA)
        if (resp.status === StatusCode.Ok) {
            const data: selectorTransversal[] = await resp.data.items;
            setOptionsGlobalQuotas(data)
        }
        return;
    }

    const tipoDiaCobro = async () => {
        const resp: AxiosResponse<ListResponseDto<selectorTransversal>> = await getValoresDominio(Dominios.DIA_COBRO)
        if (resp.status === StatusCode.Ok) {
            const data: selectorTransversal[] = await resp.data.items;
            setOptionsDiaCobro(data)
        }
        return;
    }

    const tipoEstado = async () => {
        const resp: AxiosResponse<ListResponseDto<selectorTransversal>> = await getValoresDominio(Dominios.ESTADO_PAC)
        if (resp.status === StatusCode.Ok) {
            const data: selectorTransversal[] = await resp.data.items;
            setOptionsEstado(data)
        }
        return;
    }

    const tipoMoneda = async () => {
        const resp: AxiosResponse<ListResponseDto<selectorTransversal>> = await getValoresDominio(Dominios.TIPO_MONEDA)
        if (resp.status === StatusCode.Ok) {
            const data: selectorTransversal[] = await resp.data.items;
            setOptionsMoneda(data)
        }
        return;
    }

    useEffect(() => {
        const inicializar = async () => {
            await tipoBanco();
            await tipoCuota();
            await tipoDiaCobro();
            await tipoEstado();
            await tipoMoneda();
        };

        inicializar();
    }, []);

    useEffect(() => {
        const fetchDatos = async () => {
            if (show) {
                await datosPac();
            }
        };
        fetchDatos();

        if (datosEditar?.tipoProducto === TipoProducto.MHT || datosEditar?.tipoProducto === TipoProducto.MHD) {
            setOptionsCuota(optionsGlobalQuotas.filter(x => x.value === 'Minima'))
        } else {
            setOptionsCuota(optionsGlobalQuotas)
        }

    }, [datosEditar])

    const onSubmit = async (data: PacModal) => {
        const pacData: ArgCrearPacDTO = {
            mutuoId: datosEditar!.mutuoId,
            llavePac: data.llavePac,
            bancoCodigo: data.bancoCodigo,
            fechaPrimerDescuento: data.fechaPrimerDescuento,
            tipoCuota: data.tipoCuota,
            diaCobro: Number(data.diaCobro),
            numeroMandato: data.numeroMandato ?? 0,
            numeroOperacion: data.numeroOperacion,
            cuentaCorriente: data.cuentaCorriente,
            estado: data.estado,
            montoCuota: data.montoCuota,
            tipoMoneda: data.tipoMoneda,
            observaciones: data.observaciones,
            cuotaMaxima: optionsCuotaValor?.['CuotaMaxima'],
            cuotaMinima: optionsCuotaValor?.['CuotaMinima'],
        };

        const response = await editarPac(pacData);
        if (response.status === StatusCode.Ok) {
            addToast({
                mostrar: true,
                titulo: 'Éxito',
                tipo: 'Success',
                mensaje: datosEditar ? 'La acción se ha completado con éxito. Recuerde regenerar en forma manual, el dividendo vigente de esta operación, para que los cambios se vean reflejados.'
                    : 'La acción se ha completado con éxito. Recuerde regenerar en forma manual, el dividendo vigente de esta operación, para que los cambios se vean reflejados.'
            });
            refresh();
            onHide();
            reset();
        }
    }

    function customOnHide() {
        reset()
        onHide()
    }

    const disabled: boolean = dataForm.tipoCuota === "Minima" || dataForm.tipoCuota === "Maxima";
    const getTipoMonedaByCuota = (tipoCuota: string | null | undefined) => {
        if (tipoCuota === 'Minima' || tipoCuota === 'Maxima') {
            return 'UF';
        }

        return datosEditar?.tipoMoneda || 'UF';
    }

    useEffect(() => {
        if (disabled && dataForm.tipoMoneda !== 'UF') {
            setValue('tipoMoneda', 'UF');
        }
    }, [disabled, dataForm.tipoMoneda, setValue]);


    // useEffectet llamar endpoint nuevo cada vez que datsoEdititn semueva
    //onchange cada vez que se mueva el tipo minimo maximo o intermedio y hacer la lógica para setear el monto cuota en el onchange

    const handleTipoCuota = (value: string | null) => {
        if (!value)
            return;
        setMontoCuota(datosEditar?.montoCuota || 0);
        const tipoMonedaSeleccionada = getTipoMonedaByCuota(value);

        if (value === 'Minima' && optionsCuotaValor) {
            setValue('montoCuota', optionsCuotaValor['CuotaMinima'] ?? 0);
            setValue('tipoMoneda', tipoMonedaSeleccionada)

        } else if (value === 'Maxima' && optionsCuotaValor) {
            setValue('montoCuota', optionsCuotaValor['CuotaMaxima'] ?? 0);
            setValue('tipoMoneda', tipoMonedaSeleccionada)

        }
        if (value === 'Intermedia') {
            if (isEditing && show) {
                setValue('montoCuota', montoCuotaIntermedioOriginal);
                setValue('tipoMoneda', tipoMonedaIntermedioOriginal);
            } else {
                setValue('montoCuota', 0);
                setValue('tipoMoneda', 'UF');
            }
        }

        if (!isEditing && (value === 'Minima' || value === 'Maxima')) {
            setValue('tipoMoneda', 'UF');
        }

        trigger(['montoCuota', 'tipoMoneda']);

    }
    return (
        <Dialog
            open={show}
            onClose={customOnHide}
            maxWidth='lg'
        >
            <DialogTitle>
                {isEditing ? 'Editar PAC' : 'Crear PAC'}
            </DialogTitle>
            <DialogContent>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Grid2 container spacing={2}>
                        <Grid2 size={3}>
                            <InputText
                                name="llavePac"
                                control={control}
                                label='Llave'
                                error={errors.llavePac}
                                desabilitado={!isCreateMode}
                            />
                        </Grid2>
                        <Grid2 size={3}>
                            <InputSelect
                                name="bancoCodigo"
                                control={control}
                                label="Banco"
                                options={optionsBanco}
                                error={errors.bancoCodigo}
                            />
                        </Grid2>
                        <Grid2 size={3}>
                            <InputFecha
                                name="fechaPrimerDescuento"
                                control={control}
                                label="Fecha primer descuento"
                                error={errors.fechaPrimerDescuento}
                                fecha={dataForm.fechaPrimerDescuento}
                            />
                        </Grid2>
                        <Grid2 size={3}>
                            <InputSelect
                                name="tipoCuota"
                                control={control}
                                label="Tipo cuota"
                                options={optionsCuota}
                                error={errors.tipoCuota}
                                disabled={isTradicional && isEditing}
                                onChange={(value) => { handleTipoCuota(value); }}
                            />
                        </Grid2>
                        <Grid2 size={3}>
                            <InputSelect
                                name="diaCobro"
                                control={control}
                                label="Dia cobro"
                                options={optionsDiaCobro}
                                error={errors.diaCobro}
                            />
                        </Grid2>
                        <Grid2 size={3}>
                            <InputNumber
                                name="numeroMandato"
                                control={control}
                                label="N° mandato"
                                decimales={4}
                                error={errors.numeroMandato}
                            />
                        </Grid2>
                        <Grid2 size={3}>
                            <InputText
                                name="numeroOperacion"
                                control={control}
                                label="N° operacion"
                                error={errors.numeroOperacion}
                                desabilitado={true}
                            />
                        </Grid2>
                        <Grid2 size={3}>
                            <InputText
                                name="cuentaCorriente"
                                control={control}
                                label="Cuenta corriente"
                                error={errors.cuentaCorriente}
                            />
                        </Grid2>
                        <Grid2 size={3}>
                            <InputSelect
                                name="estado"
                                control={control}
                                label="Estado"
                                options={optionsEstado}
                                error={errors.estado}
                            />
                        </Grid2>
                        <Grid2 size={3}>
                            <InputNumber
                                name="montoCuota"
                                control={control}
                                label="Monto cuota"
                                decimales={4}
                                error={errors.montoCuota}
                                disabled={isTradicional && isEditing || disabled}
                            />
                        </Grid2>
                        <Grid2 size={3}>
                            <InputSelect
                                name="tipoMoneda"
                                control={control}
                                label="Tipo moneda"
                                options={optionsMoneda}
                                error={errors.tipoMoneda}
                                disabled={dataForm.tipoCuota === "Minima" || dataForm.tipoCuota === "Maxima"}
                            />
                        </Grid2>
                        <Grid2 size={3}>
                            <InputText
                                name="observaciones"
                                control={control}
                                label="Observaciones"
                                error={errors.observaciones}
                            />
                        </Grid2>
                    </Grid2>
                    <Grid2 container spacing={1} marginTop={2} justifyContent={"flex-end"}>
                        <Grid2>
                            <MButton variant="contained" type="submit" onClick={handleSubmit(onSubmit)}>Guardar</MButton>
                        </Grid2>
                        <Grid2>
                            <MButton variant="contained" color="inherit" onClick={customOnHide}>Cancelar</MButton>
                        </Grid2>
                    </Grid2>
                </form>

            </DialogContent>
        </Dialog>
    )
}

export default ModalPac;